import { render, staticRenderFns } from "./ExtendSlide.vue?vue&type=template&id=35c1217b&scoped=true&"
import script from "./ExtendSlide.vue?vue&type=script&lang=js&"
export * from "./ExtendSlide.vue?vue&type=script&lang=js&"
import style0 from "./ExtendSlide.vue?vue&type=style&index=0&id=35c1217b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1217b",
  null
  
)

export default component.exports